import { createSwiper, withResize } from '../../components/swiper-init.js';

export function initSwiperResourcesWithResize() {
  withResize(() => {
    createSwiper('is--blog');
    createSwiper('is--articles');
    createSwiper('is--customer-stories', {
      breakpoints: {
        480: { slidesPerView: 'auto', spaceBetween: 30 },
      },
    });
    createSwiper('is--webinars');
  });
}
